<template>
  <ykc-form :model="ruleForm" :rules="rules" ref="ruleForm">
    <ykc-form-item label="电站名称">
      <span>{{ row.stationName || '——' }}</span>
    </ykc-form-item>

    <ykc-form-item label="添加方式" prop="operateObject">
      <ykc-radio
        :data="[
          { id: '1', name: '手动输入' },
          { id: '2', name: '批量上传' },
        ]"
        @change="handleOperateObjectChange"
        v-model="ruleForm.operateObject"></ykc-radio>
    </ykc-form-item>

    <ykc-form-item v-show="ruleForm.operateObject === '1'" label="用户账号" prop="userAccountText">
      <el-input
        type="textarea"
        :rows="5"
        v-model="ruleForm.userAccountText"
        placeholder="请输入用户账号，多个账号使用英文逗号分隔"></el-input>
    </ykc-form-item>

    <ykc-form-item v-show="ruleForm.operateObject === '2'" label="批量上传" prop="file">
      <ykc-upload
        class="user-upload"
        type="xlsx"
        :size="5"
        ref="file"
        :checkInfo="{ typeMess: '文件格式错误，请重新导入', sizeMess: '文件大小不超过' }"
        @handleRemove="handleRemove"
        @handleChange="fileUpload"
        :temText="linkText"
        :temhref="modelUrl"></ykc-upload>
    </ykc-form-item>
  </ykc-form>
</template>

<script>
  import { operationsStationChargeWhitelist } from '@/service/apis';

  export default {
    name: 'StationChargeWhitelistAddDrawer',
    props: {
      row: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        linkText: '白名单导入.xlsx',
        modelUrl: `${process.env.VUE_APP_OSS}/resource/白名单导入.xlsx`,
        ruleForm: {
          operateObject: '1',
          userAccountText: '',
          userAccountList: [],
          file: undefined,
        },
        rules: {
          userAccountText: [
            {
              validator: (rule, value, callback) => {
                if (this.ruleForm.operateObject === '1' && !value) {
                  callback(new Error('请输入用户账号'));
                  return;
                }
                if (value && /[，]/.test(value)) {
                  callback(new Error('不能输入中文逗号'));
                  return;
                }
                callback();
              },
              trigger: 'blur',
            },
          ],
          file: [
            {
              validator: (rule, value, callback) => {
                if (this.ruleForm.operateObject === '2' && !value) {
                  callback(new Error('请上传文件'));
                  return;
                }
                callback();
              },
              trigger: 'change',
            },
          ],
        },
      };
    },
    methods: {
      handleOperateObjectChange() {
        this.ruleForm.userAccountText = '';
        this.ruleForm.userAccountList = [];
        this.ruleForm.file = undefined;
        this.$nextTick(() => this.$refs.ruleForm.clearValidate());
      },
      handleRemove() {
        this.ruleForm.file = undefined;
        this.ruleForm.userAccountList = [];
      },
      fileUpload(file, fileList, isCheck) {
        if (!isCheck) {
          return;
        }
        this.ruleForm.file = file.raw;
        const formData = new FormData();
        formData.append('file', this.ruleForm.file);
        operationsStationChargeWhitelist
          .importUserAccounts(formData)
          .then(res => {
            this.$message.success('导入文件成功');
            this.ruleForm.userAccountList = (res?.importUserDTOS || []).map(
              item => item.userAccount
            );
          })
          .catch(() => {
            this.$refs.file.fileList = [];
          })
          .finally(() => {
            this.$refs.ruleForm.validateField('file');
          });
      },
      getAccounts() {
        if (this.ruleForm.operateObject === '1') {
          return this.ruleForm.userAccountText
            .split(',')
            .map(item => item.trim())
            .filter(Boolean);
        }
        return this.ruleForm.userAccountList;
      },
      submitForm() {
        return new Promise(resolve => {
          this.$refs.ruleForm.validate(valid => {
            if (!valid) {
              return;
            }
            operationsStationChargeWhitelist
              .addUsers({
                stationId: this.row.stationId,
                userAccountList: this.getAccounts(),
              })
              .then(count => {
                this.$message.success(`成功添加${count || 0}人进入电站充电白名单`);
                resolve();
              });
          });
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .user-upload {
    margin-bottom: 22px;
  }
</style>
